<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import { menuItems } from "./menu";

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuItems: menuItems,
      menuData: null,
      selectedType: null,
      validosRAC: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16],
      validosLOP: [18, 19, 21, 22, 23, 24, 25, 26, 27, 28],
    };
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      if(window.location.pathname == '/'){
          matchingMenuItem = links[paths.indexOf('/requests/MyRequests')];
      }else{
          const strIndex = window.location.pathname.lastIndexOf("/");
          const item = window.location.pathname.substr(0, strIndex).toString();
          matchingMenuItem = links[paths.indexOf(item)];
      }
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  computed: {
      selectedRow(){
        return this.$store.state.rutEmpresa.cuentaSeleccionada;  
      },
    selectedRut(){
        return this.$store.state.rutEmpresa.cuentaSeleccionada.value;
    },
    cuentasEmpresas(){
      return this.$store.state.rutEmpresa.cuentas;
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },

    getcuentasEmpresas() {
      this.cuentasEmpresas = this.$store.getters["rutEmpresa/cuentas"];
      this.cambiarEmpresa();
    },
    cambiarEmpresa(event) {
      this.$store.dispatch("rutEmpresa/selectAcount", event);
      this.$router.push({
          name: "my-requests"
      });
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li class="menu-title">Empresas</li>
      <li class="selectEmpresas">
        <b-form-select
          :value="selectedRut"
          :options="cuentasEmpresas"
          text-field="selectLabels"
          type="text"
          @change="cambiarEmpresa($event)"
        >
        </b-form-select>
      </li>
      <li class="menu-title">Solicitudes</li>
      <li>
        <router-link to="/requests/MyRequests" class="side-nav-link-ref">
          <i class="bx bxs-inbox"></i>
          <span>Mis Solicitudes</span>
          <span class="badge badge-pill float-right`"></span>
        </router-link>
      </li>

      <template v-if="selectedRow">
        <template v-for="item in menuItems">

          <!-- USER TYPE "LOP" -->
          <template v-if="selectedRow.tipo === 'LOP' || selectedRow.tipo === 'TODOS'">
            <li
              class="menu-title"
              v-if="item.isTitle && item.label == 'CONSULTAS LEASING OPERATIVO'"
              :key="item.id"
            >
              {{ $t(item.label) }}
            </li>
            <li
              v-if="
                !item.isTitle && !item.isLayout && validosLOP.includes(item.id)
              "
              :key="item.id"
            >
              <router-link
                :to="item.link"
                v-if="!hasItems(item)"
                class="side-nav-link-ref"
              >
                <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
                <span
                  :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                  v-if="item.badge"
                  >{{ $t(item.badge.text) }}</span
                >
              </router-link>
            </li>
          </template>

          <!-- USER TYPE "RAC" -->
          <template v-if="selectedRow.tipo == 'RAC' || selectedRow.tipo === 'TODOS'">
            <li
              class="menu-title"
              v-if="item.isTitle && item.label == 'CONSULTAS RENT A CAR'"
              :key="item.id"
            >
              {{ $t(item.label) }}
            </li>
            <li
              v-if="
                !item.isTitle && !item.isLayout && validosRAC.includes(item.id)
              "
              :key="item.id"
            >
              <router-link
                :to="item.link"
                v-if="!hasItems(item)"
                class="side-nav-link-ref"
              >
                <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
                <span
                  :class="`badge badge-pill badge-${item.badge.variant} float-right`"
                  v-if="item.badge"
                  >{{ $t(item.badge.text) }}</span
                >
              </router-link>
            </li>
          </template>
        </template>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<style scoped>
.selectEmpresas {
  width: 90%;
  margin-left: 5%;
}
</style>
